import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { Loader } from '@calendly/ui/components/loader'
import { useFlag } from '@calendly/feature-check-react'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const spaceXLarge = 'var(--spacing-1-5x, 1.5rem)'

import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import { ConfirmationFooter } from 'components/sso_confirmation_footer'
import { Container, CookieSettingsButton } from 'components/confirmation/layout'

import { Links } from './links'
import { ConfirmationHeader } from './confirmation_header'
import { ConfirmationDetails } from './confirmation_details'
import PackageDetails from './package_details'
import _CookieSettingsWrapper from "index-CookieSettingsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/index.js?styleId=CookieSettingsWrapper";
import _DetailsWrapper from "index-DetailsWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/index.js?styleId=DetailsWrapper";


const CookieSettingsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "CookieSettingsWrapper",
  styles: _CookieSettingsWrapper
})

export const Confirmation = () => {
  const { eventType, showFooter } = useConfirmationPageData()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const isPhone = useDeviceType('isPhone')
  if (eventType === undefined) return <Loader />

  return (
    <Container isPhone={isPhone} bookingAppRedesign={bookingAppRedesign}>
      <ConfirmationHeader />
      <DetailsWrapper bookingAppRedesign={bookingAppRedesign}>
        <ConfirmationDetails />
        <PackageDetails eventTypeUuid={eventType?.uuid} />
      </DetailsWrapper>
      {showFooter && <ConfirmationFooter />}
      <Links />
      {!bookingAppRedesign && (
        <CookieSettingsWrapper isPhone={isPhone}>
          <CookieSettingsButton />
        </CookieSettingsWrapper>
      )}
    </Container>
  )
}

const DetailsWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "DetailsWrapper",
  styles: _DetailsWrapper
})
